export type PaginationItem = number | 'ellipsis'

export const getPaginationRange = (page: number, totalPages: number): PaginationItem[] => {
  const windowStart = Math.max(2, page - 1)
  const windowEnd = Math.min(totalPages - 1, page + 1)

  const items: PaginationItem[] = [1]

  if (windowStart > 2) {
    items.push('ellipsis')
  }

  for (let pageNumber = windowStart; pageNumber <= windowEnd; pageNumber++) {
    items.push(pageNumber)
  }

  if (windowEnd < totalPages - 1) {
    items.push('ellipsis')
  }

  if (totalPages > 1) {
    items.push(totalPages)
  }

  return items
}
